if (!customElements.get('zd-product-services')) {
  customElements.define('zd-product-services', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-zd-variants]').textContent);
      this.request = this.querySelector('.zd-services__request');
      this.service = this.querySelector('[data-zd-service]');
      this.dialog = this.querySelector('dialog');
      this.detailAnimations = new Map();
      this.onClick = this.handleClick.bind(this);
      this.onChange = this.updateFields.bind(this);
      this.onSubmit = this.syncSelection.bind(this);
      this.addEventListener('click', this.onClick);
      this.querySelector('form').addEventListener('submit', this.onSubmit);
      this.service.addEventListener('change', this.onChange);
      this.unsubscribe = typeof subscribe === 'function' ? subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId === this.dataset.sectionId) this.updateVariant(event.data.variant);
      }) : null;
      this.updateVariant(this.variants.find(v => String(v.id) === this.querySelector('[data-zd-variant-id]').value));
      this.updateFields();
      if (this.querySelector('.zd-services__success,[role="alert"]')) this.request.open = true;
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        this.cardObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.animate([{ opacity: .55 }, { opacity: 1 }], { duration: 420, easing: 'ease-out' });
          this.cardObserver.unobserve(entry.target);
        }), { threshold: .1 });
        this.querySelectorAll('.zd-services__card').forEach(card => this.cardObserver.observe(card));
      }
    }
    disconnectedCallback() {
      this.cardObserver?.disconnect();
      this.detailAnimations.forEach((animation, details) => {
        animation.cancel();
        details.style.overflow = '';
        delete details.dataset.zdOpening;
      });
      this.detailAnimations.clear();
      this.removeEventListener('click', this.onClick);
      this.service.removeEventListener('change', this.onChange);
      this.querySelector('form').removeEventListener('submit', this.onSubmit);
      this.unsubscribe?.();
    }
    handleClick(event) {
      const requestLink = event.target.closest('[data-zd-request]');
      if (requestLink) {
        event.preventDefault();
        this.openRequest(requestLink.dataset.zdRequest);
      }
      if (event.target.closest('[data-zd-map-open]')) {
        event.preventDefault();
        this.dialog.showModal();
      }
      if (event.target.closest('[data-zd-map-close]') || event.target === this.dialog) this.dialog.close();
      const summary = event.target.closest('summary');
      if (summary && this.contains(summary)) {
        event.preventDefault();
        const details = summary.parentElement;
        const open = details.dataset.zdOpening ? details.dataset.zdOpening !== 'true' : !details.open;
        this.toggleDetails(details, open);
        if (details === this.request && open) this.syncSelection();
      }
    }
    toggleDetails(details, open) {
      const start = details.getBoundingClientRect().height;
      this.detailAnimations.get(details)?.cancel();
      this.detailAnimations.delete(details);
      details.style.overflow = '';
      delete details.dataset.zdOpening;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
        details.open = open;
        return;
      }
      details.open = true;
      const style = getComputedStyle(details);
      const closedHeight = details.querySelector('summary').getBoundingClientRect().height
        + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)
        + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const end = open ? details.getBoundingClientRect().height : closedHeight;
      details.style.overflow = 'hidden';
      details.dataset.zdOpening = String(open);
      const animation = details.animate([{ height: `${start}px` }, { height: `${end}px` }], { duration: 280, easing: 'cubic-bezier(.22,.61,.36,1)' });
      this.detailAnimations.set(details, animation);
      animation.onfinish = () => {
        details.open = open;
        details.style.overflow = '';
        delete details.dataset.zdOpening;
        this.detailAnimations.delete(details);
      };
    }
    openRequest(service) {
      this.service.value = service;
      this.updateFields();
      this.syncSelection();
      if (!this.request.open || this.request.dataset.zdOpening === 'false') this.toggleDetails(this.request, true);
      const scrollToRequest = () => this.request.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      const expansion = this.detailAnimations.get(this.request);
      if (expansion) expansion.finished.then(scrollToRequest).catch(() => {});
      else scrollToRequest();
      this.querySelector('[name="contact[name]"]').focus({ preventScroll: true });
    }
    syncSelection() {
      const quantity = document.querySelector(`input[name="quantity"][form="${this.dataset.productForm}"]`);
      this.querySelector('[data-zd-quantity]').value = quantity?.value || '1';
      const idInput = document.getElementById(this.dataset.productForm)?.querySelector('[name="id"]');
      this.updateVariant(this.variants.find(v => String(v.id) === idInput?.value));
    }
    updateVariant(variant) {
      if (!variant) return;
      this.querySelector('[data-zd-variant]').value = variant.title;
      this.querySelector('[data-zd-variant-id]').value = variant.id;
      const urlInput = this.querySelector('[data-zd-product-url]');
      const url = new URL(urlInput.value);
      url.searchParams.set('variant', variant.id);
      urlInput.value = url.href;
      const size = Number(variant.title.match(/(\d+(?:[.,]\d+)?)\s*["″]/)?.[1]?.replace(',', '.'));
      const small = size >= 15 && size < 40;
      this.querySelector('[data-zd-price="stand"]')?.replaceChildren(String(small ? 129 : 189));
      this.querySelector('[data-zd-price="wall"]')?.replaceChildren(String(small ? 299 : 379));
      const label = this.querySelector('[data-zd-size]');
      if (label) label.textContent = small ? this.dataset.smallLabel : this.dataset.largeLabel;

    }
    updateFields() {
      const installation = this.service.value === 'installation';
      this.querySelectorAll('[data-zd-location],[data-zd-mount]').forEach(field => {
        field.hidden = !installation;
        const input = field.querySelector('input,select');
        input.disabled = !installation;
        input.required = installation && field.hasAttribute('data-zd-location');
      });
    }
  });
}
